import { render, staticRenderFns } from "./UserDetailAppointments.vue?vue&type=template&id=1b264afa"
import script from "./UserDetailAppointments.vue?vue&type=script&lang=js"
export * from "./UserDetailAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports